import { AWUserAttributes, UserAttributeType } from '@blk/awt-userpreference';
import { prefixEnumForAGraph } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { userPreferenceApi } from './Base';

const path = '/v1/user-attributes';

export async function getAllUserAttributes(): Promise<AWUserAttributes> {
  const response = await userPreferenceApi.get<AWUserAttributes>(path);
  return response.data;
}

/**
 * @deprecated Use patchUserAttributes instead
 */
export function postUserAttributes(newUserAttributes: AWUserAttributes) {
  return userPreferenceApi.post<AWUserAttributes>(path, newUserAttributes);
}

export function patchUserAttributes(
  newUserAttributes: Partial<AWUserAttributes>,
  userAttributeType: UserAttributeType
) {
  return userPreferenceApi.patch<AWUserAttributes>(path, newUserAttributes, {
    params: {
      userAttributeType: prefixEnumForAGraph(userAttributeType, 'USER_ATTRIBUTE_TYPE_', isAGraphEnabled()),
    },
  });
}

export function deleteAllUserAttributes() {
  return userPreferenceApi.delete<void>(path);
}
